import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import type { Address } from 'viem';
import { db } from './firebase';

export type TxType =
  | 'swap'
  | 'addLiquidity'
  | 'removeLiquidity'
  | 'stake'
  | 'unstake'
  | 'harvest'
  | 'farmDeposit'
  | 'farmWithdraw'
  | 'earnDeposit'
  | 'earnWithdraw'
  | 'rwaBuy'
  | 'rwaSell'
  | 'rwaRedeem'
  | 'launchpadBuy'
  | 'lendDeposit'
  | 'lendWithdraw'
  | 'borrow'
  | 'repay'
  | 'predictionBet'
  | 'predictionClaim'
  | 'bridgeLock'
  | 'bridgeUnlock';

export async function logTransaction(entry: {
  type: TxType;
  hash: `0x${string}`;
  account: Address;
  chainId: number;
  details: Record<string, string>;
}) {
  try {
    await addDoc(collection(db, 'transactions'), {
      ...entry,
      createdAt: serverTimestamp(),
    });
  } catch (err) {
    // logging is best-effort analytics — never block or surface errors over the
    // trade itself, which already succeeded on-chain by the time this runs.
    console.warn('logTransaction failed', err);
  }
}
